export default {
  path: '',
  component: () => import(`@/component/admin-layout/index.vue`),
  children: [
    {
      path: '/admin/desktop',
      name: 'admin-desktop',
      component: () => import(`./index.vue`),
      meta: {
        entity_for_history_tag: {
          name: `桌面`,
        },
        entity_list_for_breadcrumb: [
          {name: `示例功能`},
          {name: `桌面`},
        ],
      },
    }
  ],
};
